export const SET_SEARCH_ITEMS = "SET_SEARCH_ITEMS";
